<div class="icons">
  <div
    class="icon-wrapper"
    *ngFor="let icon of icons"
  >
    <mat-icon [svgIcon]="icon"></mat-icon>
  </div>
</div>